import React,{Component} from 'react';
import SweetAlert from "sweetalert2-react";

class ErrorAlert extends Component{

    state = {
        error: true
    }

    toggleAlert = () => {
        window.location = this.props.redirectRoute !== undefined ? this.props.redirectRoute : ''
    };

    render(){
        let { error } = this.state;
        return(
            <div>
                  <SweetAlert
                    show={error}
                    title={this.props.title}
                    type="error"
                    text={this.props.message}
                    onConfirm={() => this.toggleAlert()}
                  />
            </div>
        );
    };
};

export default ErrorAlert;